
export const LABELS = {
  role: {
    teacher: 'Ansvarig',
    teacher_plural: 'Ansvariga',
    student: 'Säljare',
    student_plural: 'Säljare',
    admin: 'Admin',
  },
  group: {
    singular: 'Grupp',
    plural: 'Grupper',
    definite: 'Gruppen',
    currency: 'Gruppkassan',
    journey: 'Gruppresan',
  },
  nav: {
    classroom: 'Grupprummet',
  }
};